import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { billingPath } from "@/utils/accountRoutes";
import { spotlightTargetProps } from "@/components/featureSpotlight/spotlightTargetProps";

/**
 * The closing strip: help on the left, money on the right.
 *
 * Billing lives here rather than in a card because on a healthy account it is
 * reference information, not a task. When it stops being healthy the state
 * surfaces through the alert pill and the task list instead — the strip just
 * changes tone in place, so the user never has to hunt for where the status
 * moved to.
 */

const TONE_PILL = {
  danger:
    "bg-[rgba(224,72,58,.12)] text-[#c23b2f] dark:bg-[rgba(255,90,77,.18)] dark:text-[#ff8b7f]",
  info: "bg-[rgba(91,91,214,.12)] text-[#4f4fc4] dark:bg-[rgba(139,139,255,.2)] dark:text-[#b0b0ff]",
  success:
    "bg-[rgba(18,156,104,.12)] text-[#0f8a5c] dark:bg-[rgba(126,226,168,.16)] dark:text-[#7ee2a8]",
};

const LINK =
  "text-[12.5px] font-semibold leading-none text-[#5c5f70] transition-colors hover:text-[#15161f] dark:text-white/[.62] dark:hover:text-white";

export default function BillingFooter({ billing }) {
  const { user } = useAuth();

  return (
    <div className="flex flex-wrap items-center gap-4 px-1 pt-[30px]">
      <Link to="/internal/support" className={LINK} {...spotlightTargetProps("dashboard.help-articles-link")}>
        Ver todos os artigos →
      </Link>

      {billing && (
        <span className="ml-auto flex items-center gap-2.5" {...spotlightTargetProps("dashboard.billing-status")}>
          <span className="text-[12.5px] font-medium leading-none text-[#5c5f70] dark:text-white/[.62]">
            {billing.label}
          </span>
          <span
            className={`inline-flex flex-none items-center whitespace-nowrap rounded-[11px] px-[9px] py-1 text-[9.5px] font-bold leading-none tracking-[.08em] ${
              TONE_PILL[billing.tone] || TONE_PILL.success
            }`}
          >
            {billing.status}
          </span>
          <Link
            to={billingPath(user?.accountId)}
            className={`${LINK} whitespace-nowrap`}
          >
            Billing →
          </Link>
        </span>
      )}
    </div>
  );
}
